import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import ClassRegistrationConfirmPurchaseForm from './ClassRegistrationConfirmPurchaseForm';
import ClassRegistrationSuccess from './ClassRegistrationSuccess';
import { selectDefaultSource } from '../../../redux/selectors';
import Loading from '../../../../common/components/Loading';
import UpdateBillingContent from '../../../../common/components/UpdateBillingContent';

class ClassRegistrationModal extends Component {
  static propTypes = {
    classEntity: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    message: '',
    page: 1,
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.classRegistration.get('loading') &&
      nextProps.classRegistration.get('loaded') &&
      this.state.page === 1
    ) {
      this.nextPage();
    }
  }

  componentWillUnmount() {
    this.props.dispatch(reset('sessionRequestForm'));
  }

  nextPage = (values = {}) => {
    this.setState(state => Object.assign({ page: state.page + 1 }, values));
  };

  render() {
    const { classEntity, classRegistration, onCancel, onSubmit, school, source } = this.props;
    const { page, message } = this.state;

    if (!source) {
      return <UpdateBillingContent />;
    }

    return (
      <div className="gs-page__modal">
        {classRegistration.get('loading') ? (
          <div className="modal--loading">
            <Loading />
          </div>
        ) : null}
        {page === 1 && (
          <ClassRegistrationConfirmPurchaseForm
            classEntity={classEntity}
            initialValues={{ message }}
            onCancel={onCancel}
            onSubmit={onSubmit}
            school={school}
            source={source}
            submitError={classRegistration.get('error')}
          />
        )}
        {page === 2 && <ClassRegistrationSuccess classEntity={classEntity} onClose={onCancel} school={school} />}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    classRegistration: state.subscription.golfSchools.classRegistration,
    source: selectDefaultSource(state),
  };
};

export default connect(mapStateToProps)(ClassRegistrationModal);



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/class-registration/ClassRegistrationModal.js